/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Mapping between internal and external segment IDs
*/
export class V3StackAdaptSegmentMapping {
    /**
    * Internal segment ID
    */
    'internalSegmentId'?: string;
    /**
    * External segment ID
    */
    'externalSegmentId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "internalSegmentId",
            "baseName": "internal_segment_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalSegmentId",
            "baseName": "external_segment_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptSegmentMapping.attributeTypeMap;
    }

    public constructor() {
    }
}

